/**
 * Created by LifeSoft on 18/10/18.
 */
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {DefaultApiService} from '../default-api.service';
@Injectable()
export class ExaminationIndexResolver implements Resolve<any> {

  constructor(private defaultAPIService: DefaultApiService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const url = 'api/v1/examinations/get-data-for-examination-control';
    return this.defaultAPIService.getAll(url);
  }

}
